import React, { Component } from 'react';
import { Layout } from 'antd';
import { connect } from '@souche-f2e/muji';
// import { dispatch } from '@@/store';
import SiderMenu from '@/components/SiderMenu';
import Header from './Header';
import Footer from './Footer';
import menuData from '@/menu-data';
import styles from './index.module.less';
const mapStateToProps = ({ global, setting, router }) => {
  return {
    // collapsed: global.collapsed,
    sso: global.sso,
    layout: setting.layout,
    // contentWidth: setting.contentWidth,
    // hideLayoutInIframe: setting.hideLayoutInIframe,
    currentRoute: router,
  };
};

class BasicLayout extends Component {
  constructor() {
    super(...arguments);
    // this.onCollapse = (collapsed) => {
    //   dispatch.global.SET_COLLAPSED(collapsed);
    // };
  }

  componentDidMount() {
    // dispatch.global.loadSSOUser();
  }

  render() {
    const {
      layout,
      // contentWidth,
      // collapsed,
      currentRoute,
      sso,
      hideLayoutInIframe,
      children,
    } = this.props;
    // 自定义BaseMenu主题，默认'light'
    const myTheme = "dark";
    if (hideLayoutInIframe && window.top !== window.self) {
      return children;
    }
    let currentLayout = (currentRoute.path === '/signIn') ? (
          <Layout style={{ minHeight: '100vh'}}>
          <Layout.Content className={styles.content}>{children}</Layout.Content>
          </Layout>
        ) : (
          <Layout style={{minHeight: '100vh'}}>
              <Header
                menuData={menuData}
                currentRoute={currentRoute}
                layout={layout}
                sso={sso}
                myTheme={myTheme}
              />
              <Layout.Content className={styles.content}>{children}</Layout.Content>
            </Layout>
        )

    return (
      <div>
        {currentLayout}
      </div>
      
    )
  }
}

export default connect(mapStateToProps)(BasicLayout);
